import * as React from "react";
export function SolanaIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={17}
      fill="none"
      {...props}
    >
      <g clipPath="url(#idwf70r6dl_1737503424662_1_svg__a)">
        <path
          fill="url(#idwf70r6dl_1737503424662_1_svg__b)"
          d="M3.204 12.715a.64.64 0 0 1 .455-.189H19.41c.287 0 .43.347.227.55l-3.112 3.11a.64.64 0 0 1-.456.189H.32a.322.322 0 0 1-.228-.55z"
        />
        <path
          fill="url(#idwf70r6dl_1737503424662_1_svg__c)"
          d="M3.204 1.092a.64.64 0 0 1 .455-.189H19.41c.287 0 .43.347.227.55l-3.112 3.11a.64.64 0 0 1-.456.189H.32a.322.322 0 0 1-.228-.55z"
        />
        <path
          fill="url(#idwf70r6dl_1737503424662_1_svg__d)"
          d="M16.526 6.868a.64.64 0 0 0-.456-.188H.32a.322.322 0 0 0-.228.55l3.113 3.11c.12.12.284.188.455.188H19.41c.287 0 .43-.347.227-.55z"
        />
      </g>
      <defs>
        <linearGradient
          id="idwf70r6dl_1737503424662_1_svg__b"
          x1={13.34}
          x2={2.438}
          y1={-3.335}
          y2={17.546}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFA3" />
          <stop offset={1} stopColor="#DC1FFF" />
        </linearGradient>
        <linearGradient
          id="idwf70r6dl_1737503424662_1_svg__c"
          x1={13.34}
          x2={2.438}
          y1={-3.339}
          y2={17.541}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFA3" />
          <stop offset={1} stopColor="#DC1FFF" />
        </linearGradient>
        <linearGradient
          id="idwf70r6dl_1737503424662_1_svg__d"
          x1={13.34}
          x2={2.438}
          y1={-3.336}
          y2={17.545}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FFA3" />
          <stop offset={1} stopColor="#DC1FFF" />
        </linearGradient>
        <clipPath id="idwf70r6dl_1737503424662_1_svg__a">
          <path fill="#fff" d="M0 .906h19.752V16.39H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
